export const FOREX_QUOTES_API_KEY = 'mKJudHyyP1CsMQnOqTly82q81Fl82YDr'
